// 9fbef606107a605d69c0edbcd8029e5d
import { AB_TEST_STORE_PATTERN } from '@tcp/core/src/constants/reducer.constants';

export const FETCH_AB_TEST_DATA = `${AB_TEST_STORE_PATTERN}FETCH_AB_TEST_DATA`;
export const SET_AB_TEST_DATA = `${AB_TEST_STORE_PATTERN}SET_AB_TEST_DATA`;
export const FETCH_DY_ABTESTS_DATA = `${AB_TEST_STORE_PATTERN}FETCH_DY_ABTESTS_DATA`;
export const APPEND_DY_AB_TEST_DATA = `${AB_TEST_STORE_PATTERN}APPEND_DY_AB_TEST_DATA`;

export default {
  FETCH_AB_TEST_DATA,
  SET_AB_TEST_DATA,
  FETCH_DY_ABTESTS_DATA,
  APPEND_DY_AB_TEST_DATA,
};
